import MentoringProgramContext from 'athena/components/mentoring-program/context';
import { useContext, useMemo } from 'react';
import { MentorRequestParticipantType } from 'redux/schemas/models/mentor-request';

const useMentorAvailability = (participant: MentorRequestParticipantType | null | undefined) => {
  const { mentoringProgram } = useContext(MentoringProgramContext);
  const assignedConnections = participant?.assignedConnections ?? [];
  const participantConcurrentConnections = participant?.concurrentMentorConnection ?? 0;

  const {
    mentorCapacityEnabled,
    concurrentMentorConnection: maxMenteesInProgram,
  } = mentoringProgram || {};

  const totalCapacity = mentorCapacityEnabled
    ? participantConcurrentConnections
    : maxMenteesInProgram;

  const calculatedAvailability = totalCapacity - assignedConnections.length;
  const availability = participant?.availability ?? calculatedAvailability;
  const finalAvailability = Math.max(0, availability);
  const isAvailable = participant?.isAvailable ?? (finalAvailability > 0);

  return useMemo(() => ({
    availability: finalAvailability,
    currentCapacity: assignedConnections.length,
    totalCapacity,
    isAvailable,
  }), [finalAvailability, totalCapacity, isAvailable]);
};

export default useMentorAvailability;
